import { render, staticRenderFns } from "./AdminChapter_edit.vue?vue&type=template&id=60ccaebe&"
import script from "./AdminChapter_edit.vue?vue&type=script&lang=js&"
export * from "./AdminChapter_edit.vue?vue&type=script&lang=js&"
import style0 from "./AdminChapter_edit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports